import {Component, OnInit, ViewChild, AfterViewInit, ElementRef, OnDestroy} from '@angular/core';
import {StorageService} from '../../../Services/storage.service';
import {DataService} from '../../../Services/data.service';
import {Title} from '@angular/platform-browser';
import {DateFilterService} from '../../../Services/dateFilter.service';
import {ResponseModel} from '../../../DataModels/response-model';
import {PermissionsService} from '../../../Services/permissions.service';
import {Subscription} from 'rxjs';
import {ListPageBase} from '../../list-page-base';
import {BsToastService} from '../../../Services/bs-toast-service';
import {ConfirmDialogService} from '../../../Services/confirm-dialog.service';
import {InvoiceDocumentService} from '../../../Services/invoice-document.service';
import {EmailModel} from '../../../DataModels/email-model';
import {Modal} from 'bootstrap';
import {DatePipe} from '@angular/common';
import {take} from 'rxjs/operators';
import {firstValueFrom} from 'rxjs';
import {NgZone} from '@angular/core';

/** AR-only batch type constant */
const AR_BATCH_TYPE = '2';

export interface InvoiceListArVm {
  list: any[];
  batches: any[];
  shipments: any[];
  workorders: any[];
  quotes: any[];
  include: string;
  batchId: string;
  invoiceSearch: string;
  invoiceFromDate: string;
  invoiceToDate: string;
  invoiceToDateOpen: boolean;
  invoiceFromDateOpen: boolean;
  unpaidInvoices: boolean;
  searching: boolean;
  buttonsDisabled: boolean;
  searchHidden: boolean;
  batchesHidden: boolean;
  owingSelected: number;
  totalSelected: number;
  Preferences: any;
  permissions: any;
  title: string;
  tempDescription: string;
  subLedger: string;
}

@Component({
  selector: 'app-invoice-list-ar',
  templateUrl: './invoice-list-ar.component.html',
  styleUrls: ['./invoice-list-ar.component.css'],
  standalone: false
})
export class InvoiceListArComponent extends ListPageBase implements OnInit, AfterViewInit, OnDestroy {

  constructor(
    private localStorage: StorageService,
    private tableDataService: DataService,
    private notification: BsToastService,
    private dateFilter: DateFilterService,
    private titleService: Title,
    private confirmDialogService: ConfirmDialogService,
    private invoiceDoc: InvoiceDocumentService,
    private datePipe: DatePipe,
    private permissionsService: PermissionsService,
    private ngZone: NgZone
  ) {
    super();
  }

  get hasEditReceivableInvoicePermission(): boolean {
    return this.permissionsService.Get('Admin') ||
      this.permissionsService.Get('EditReceivableInvoices');
  }

  vm: InvoiceListArVm = {
    list: [],
    batches: [],
    shipments: [],
    workorders: [],
    quotes: [],
    include: 'all',
    batchId: '',
    invoiceSearch: '',
    invoiceFromDate: '',
    invoiceToDate: '',
    invoiceToDateOpen: false,
    invoiceFromDateOpen: false,
    unpaidInvoices: false,
    searching: false,
    buttonsDisabled: false,
    searchHidden: false,
    batchesHidden: true,
    owingSelected: 0,
    totalSelected: 0,
    Preferences: {},
    permissions: {},
    title: $localize`:Receivable Invoices@@receivableInvoices:Receivable Invoices`,
    tempDescription: '',
    subLedger: 'ar',
  };

  isLoaded = false;
  checkAll = false;
  selectedRecords: any[] = [];
  subscriptionGroup: Subscription[] = [];

  // For template comparisons: today's date formatted as yyyyMMdd
  todayYmd: string;

  // Email support
  emailDocumentName = 'Receivable Invoice';
  reportDataToSendInEmail: EmailModel = new EmailModel();


  // @ViewChild('sendEmailModal', { static: false }) sendEmailModalRef: ElementRef;
  @ViewChild('myArModal', {read: ElementRef}) modalElementRef!: ElementRef;


  async ngOnInit() {
    this.todayYmd = this.datePipe.transform(new Date(), 'yyyyMMdd');
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));

    if (this.vm.Preferences?.ShowBatches) {
      this.vm.batchesHidden = !this.vm.Preferences.ShowBatches;
    }

    this.restorePagerState();

    await this.search();
  }

  ngOnDestroy(): void {
    this.subscriptionGroup.forEach(s => s.unsubscribe());
  }

  ngAfterViewInit() {
    this.titleService.setTitle(this.vm.title);
  }

  protected override get pagerKey(): string {
    return this.pagerStatus.buildKey(this.router.url, {subLedger: 'ar'});
  }

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  async getPagedApiData() {
    this.checkAll = false;
    this.isLoaded = false;
    this.vm.searching = true;
    this.vm.buttonsDisabled = true;
    this.vm.batchId = '';
    this.vm.tempDescription = '';

    const unPaidInput = document.getElementById('unPaid') as HTMLInputElement;
    this.vm.unpaidInvoices = unPaidInput ? unPaidInput.checked : false;

    const paramString = 'batchType=' + AR_BATCH_TYPE
      + '&search=' + (this.vm.invoiceSearch || '')
      + '&fromDate=' + (this.vm.invoiceFromDate ? this.dateFilter.GetDateFormat(this.vm.invoiceFromDate) : '')
      + '&toDate=' + (this.vm.invoiceToDate ? this.dateFilter.GetDateFormat(this.vm.invoiceToDate) : '')
      + '&unpaidInvoices=' + (this.vm.unpaidInvoices || false)
      + '&pageNumber=' + (this.page - 1)
      + '&pageSize=' + this.pageSize
      + '&recurring=0'
      + '&include=' + (this.vm.include || 'all');

    try {
      const result: ResponseModel = await firstValueFrom(
        this.tableDataService.getApiListData('entry', '?' + paramString).pipe(take(1))
      ) as ResponseModel;
      this.vm.list = result.Data;
      console.log('AR invoices fetch:', result.Data);
      this.totalRecords = result.totalRecords;
      this.paginate(false);
      this.convertToNumbers();
      this.vm.searching = false;
      this.vm.buttonsDisabled = false;
      this.isLoaded = true;
    } catch (e) {
      console.error('Error fetching AR invoices:', e);
      this.vm.searching = false;
      this.vm.buttonsDisabled = false;
      this.isLoaded = true;
    }
  }

  async search() {
    this.isLoaded = false;
    this.vm.searching = true;
    this.vm.buttonsDisabled = true;
    this.vm.batchId = '';
    this.vm.tempDescription = '';

    const unPaidInput = document.getElementById('unPaid') as HTMLInputElement;
    this.vm.unpaidInvoices = unPaidInput ? unPaidInput.checked : false;

    const paramString = 'batchType=' + AR_BATCH_TYPE
      + '&search=' + (this.vm.invoiceSearch || '')
      + '&fromDate=' + (this.vm.invoiceFromDate ? this.dateFilter.GetDateFormat(this.vm.invoiceFromDate) : '')
      + '&toDate=' + (this.vm.invoiceToDate ? this.dateFilter.GetDateFormat(this.vm.invoiceToDate) : '')
      + '&unpaidInvoices=' + (this.vm.unpaidInvoices || false)
      + '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0)
      + '&pageSize=' + this.pageSize
      + '&recurring=0'
      + '&include=' + (this.vm.include || 'all');

    try {
      const result: ResponseModel = await firstValueFrom(
        this.tableDataService.getApiListData('entry', '?' + paramString).pipe(take(1))
      ) as ResponseModel;
      this.vm.list = result.Data;
      console.log('AR invoices:', result.Data);
      this.totalRecords = result.totalRecords;
      this.paginate(false);
      this.convertToNumbers();
      this.vm.searching = false;
      this.vm.buttonsDisabled = false;
      this.isLoaded = true;
    } catch (e) {
      console.error('Error fetching AR invoices:', e);
      this.vm.searching = false;
      this.vm.buttonsDisabled = false;
      this.isLoaded = true;
    }
  }

  convertToNumbers() {
    for (const [x] of Object.entries(this.vm.list)) {
      this.vm.list[x].detail_total = Number(this.vm.list[x].detail_total);
      this.vm.list[x].payment_applied_total = Number(this.vm.list[x].payment_applied_total);
      this.vm.list[x].audit_sequence = Number(this.vm.list[x].audit_sequence);
    }
  }

  selectRow(rec: any, checked: boolean) {
    if (this.checkAll && rec) {
      this.checkAll = false;
    }
    if (checked) {
      this.vm.list.forEach((item: any) => {
        if (item.id === rec) {
          item.selected = true;
        }
      });
    } else {
      this.vm.list.forEach((item: any) => {
        if (item.id === rec) {
          item.selected = false;
        }
      });
    }
  }

  selectAllRows(checked: boolean) {
    this.vm.list.forEach((item: any) => {
      item.selected = false;
    });
    if (checked) {
      this.vm.list.forEach((item: any) => {
        if (!item.locked && (item.detail_total - item.payment_applied_total) > 0) {
          item.selected = true;
        }
      });
    }
  }

  isAllChecked(): boolean {
    return this.vm.list.every((x: any) => x.selected);
  }

  confirmDeleteSelected() {
    const selected = this.vm.list.filter((x: any) => x.selected);
    if (!selected.length) {
      this.notification.showWarningToast($localize`:No records selected@@noRecordsSelected:No records selected`);
      return;
    }
    this.confirmDialogService.confirmThis(
      [$localize`:Confirm Delete@@confirmDelete:Confirm Delete`, $localize`:Delete selected records?@@deleteSelectedRecords:Delete selected records?` + ` (${selected.length})`],
      () => {
        this.deleteSelected();
      },
      () => {
      }
    );
  }

  async deleteSelected() {
    const selected = this.vm.list.filter((x: any) => x.selected && !x.locked);
    for (const item of selected) {
      try {
        await firstValueFrom(this.tableDataService.deleteDataById('entry', item.id).pipe(take(1)));
      } catch (e) {
        console.error('Error deleting record:', item.id, e);
      }
    }
    await this.search();
  }

  includeUnItems(event: any = null) {
    this.vm.unpaidInvoices = !!event;
    this.pageSize = this.appConfig.ListPageSize;
    this.page = 1;
    this.getPagedApiData();
  }

  hideBatches() {
    this.vm.batchesHidden = !this.vm.batchesHidden;
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }

  clearServerSearch(value: any) {
    this.vm.invoiceSearch = value.searchTerm;
    this.vm.invoiceFromDate = value.fromDate;
    this.vm.invoiceToDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  serverSearch(value: any) {
    this.vm.invoiceSearch = value.searchTerm;
    this.vm.invoiceFromDate = value.fromDate;
    this.vm.invoiceToDate = value.toDate;
    this.page = 1;
    this.getPagedApiData().then();
  }

  onNavigate(id: any, print = false) {
    if (print) {
      try {
        const row = (this.vm.list || []).find((r: any) => String(r?.id) === String(id));
        const total = Number(row?.detail_total || 0);
        const docType = total < 0 ? 'ar-credit' : 'ar';
        this.invoiceDoc.printById(String(id), docType);
        return;
      } catch (e) {
        this.router.navigate(['/transactions/invoice/ar/form'], {queryParams: {invoiceId: id, action: 'print'}}).then();
        return;
      }
    }
    this.router.navigate(['/transactions/invoice/ar/form'], {queryParams: {invoiceId: id}}).then();
  }

  async email(id: any) {
    try {
      const row = (this.vm.list || []).find((r: any) => String(r?.id) === String(id));
      const total = Number(row?.detail_total || 0);
      const docType = total > 0 ? 'ar' : 'ar-credit';
      const emailObj: any = await this.invoiceDoc.buildEmailModelById(String(id), docType);
      this.reportDataToSendInEmail = emailObj;
      this.reportDataToSendInEmail.print_orientation = 'portrait';
      this.reportDataToSendInEmail.convert_attachment_to = 'pdf';
      this.reportDataToSendInEmail.includeAttachment = true;

      console.log('emailObj', this.reportDataToSendInEmail);

      // Target the exact local element reference instead of document.getElementById
      if (this.modalElementRef) {
        // Find the actual modal div inside your child component template
        const modalDiv = this.modalElementRef.nativeElement.querySelector('.modal');
        if (modalDiv) {
          const modal = Modal.getOrCreateInstance(modalDiv);
          modal.show();
        }
      }
    } catch (e) {
      console.error('Unable to open email modal for invoice id:', id, e);
      this.notification.showErrorToast(`Unable to prepare email`);
    }
  }

  async getBatchItems(batchId: string) {
    this.vm.batchId = batchId;
    this.vm.searching = true;
    this.vm.buttonsDisabled = true;
    this.isLoaded = false;

    const paramString = 'batchId=' + (batchId || '')
      + '&batchType=' + AR_BATCH_TYPE
      + '&pageNumber=0'
      + '&pageSize=' + this.pageSize;

    try {
      const result: ResponseModel = await firstValueFrom(
        this.tableDataService.getApiListData('entry', '?' + paramString).pipe(take(1))
      ) as ResponseModel;
      this.vm.list = result.Data;
      this.totalRecords = result.totalRecords;
      this.paginate(false);
      this.convertToNumbers();
      this.vm.searching = false;
      this.vm.buttonsDisabled = false;
      this.isLoaded = true;
    } catch (e) {
      console.error('Error fetching batch items:', e);
      this.vm.searching = false;
      this.vm.buttonsDisabled = false;
      this.isLoaded = true;
    }
  }

  getShipments() {
    const paramString = 'batchType=11&search=&fromDate=&toDate=&unshipped=&uninvoiced=true&pageNumber=0&pageSize=999999';
    this.subscriptionGroup.push(this.tableDataService.getApiListData('ListShipments?' + paramString).subscribe((result: ResponseModel) => {
      this.vm.shipments = result.Data;
    }));
  }

  getWorkOrders() {
    const paramString = 'incompleteWorkOrders=false&numberOfResults=999999&assignedToMe=false&status=Completed&search=&fromDate=&toDate=&notInvoiced=true&pageNumber=0&pageSize=999999';
    this.subscriptionGroup.push(this.tableDataService.getData('WorkOrder', '?' + paramString).subscribe((result: ResponseModel) => {
      this.vm.workorders = result.Data;
    }));
  }

  getQuotes() {
    const paramString = 'batchType=8&search=&fromDate=&toDate=&unshipped=&uninvoiced=true&numberOfResults=999999&pageNumber=0&pageSize=999999';
    this.subscriptionGroup.push(this.tableDataService.getData('entry', '?' + paramString).subscribe((result: ResponseModel) => {
      this.vm.quotes = result.Data;
    }));
  }

}
